import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-790e5f22")
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({i:true})
}
const _hoisted_2 = {
  key: 0,
  class: "t"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Ripple = _resolveComponent("Ripple")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args))),
    class: _normalizeClass({
    checkbox:true,
    clickable:true,
    noSelect:true,
  })
  }, [
    _createVNode(_component_Ripple),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.toggled)
        ? (_openBlock(), _createBlock(_component_MovingIcon, {
            key: 0,
            name: "check",
            autoplay: true,
            type: "svg",
            ref: "icon"
          }, null, 512))
        : _createCommentVNode("", true),
      (!_ctx.toggled)
        ? (_openBlock(), _createBlock(_component_MovingIcon, {
            key: 1,
            name: "check_empty",
            autoplay: true,
            type: "svg",
            ref: "icon"
          }, null, 512))
        : _createCommentVNode("", true)
    ]),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true)
  ]))
}